const MenuData = {
    projetos:{
        en: "Projects",
        br: "Projetos"
    },
    legado:{
        en: "Legacy",
        br: "Legado"
    },
    contato:{
        en: "Contact",
        br: "Contato"
    }
}
export default MenuData;